import _extends from '@babel/runtime/helpers/extends';
import { px2rem } from '../utils/helpers/style.js';
import { spacing } from '../constants/spacing.js';

var notificationWebAttributes = {
  paddingHorizontal: spacing.xxs,
  paddingVertical: spacing.xxs
};
var notificationThemeWeb = _extends({}, notificationWebAttributes, {
  variants: {
    condensed: {
      paddingHorizontal: spacing.xxs,
      paddingVertical: px2rem(12)
    }
  }
});
var notificationNativeAttributes = {
  paddingHorizontal: 8,
  paddingTop: 16,
  paddingBottom: 16,
  icon: {
    marginHorizontal: 8
  }
};
var notificationThemeNative = _extends({}, notificationNativeAttributes, {
  variants: {
    condensed: {
      paddingTop: 12,
      paddingBottom: 16
    }
  }
});

export { notificationNativeAttributes, notificationThemeNative, notificationThemeWeb };
